module.exports = __webpack_public_path__ + "static/la_camara-fb9fd28c4626ab25ff083d60f4a9e66c.jpg";